import React from "react";
import { Avatar, Button, Input } from "antd";
import { avatar2 } from "../../../commons/PanelImagepath";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import AuthLayout from "../login/AuthLayout";

const Lockscreen = () => {
  const { t } = useTranslation("dashboard");
  const config = "/";
  return (
    <AuthLayout>
      <div className="auth-page__user">
        <Avatar size={72} src={avatar2} alt={t("John Doe")} />
        <h4>{t("John Doe")}</h4>
      </div>
      <form action={`${config}admin`}>
        <div className="auth-page__field">
          <label className="auth-page__label" htmlFor="lockscreen-password">
            {t("Password")}
          </label>
          <Input.Password
            id="lockscreen-password"
            name="password"
            size="large"
            autoComplete="current-password"
            placeholder={t("Password")}
          />
        </div>
        <Button type="primary" htmlType="submit" size="large" block>
          {t("Enter")}
        </Button>
      </form>
      <div className="auth-page__footer">
        {t("Sign in as a different user?")} <Link to="/login">{t("Login")}</Link>
      </div>
    </AuthLayout>
  );
};

export default Lockscreen;
